<template>
	<div class="seomain">
	  <st-header
	    :title="formData.id ? '编辑转仓单' : '添加转仓单'"
	    :back-able="true"
	  >
	  </st-header>
		<van-steps :active="act_step">
		  <van-step @click="act_step = 0"><div @click="act_step = 0">基本信息</div></van-step>
		  <van-step @click="act_step = 1"><div @click="act_step = 1">产品</div></van-step>
			<van-step @click="act_step = 2"><div @click="act_step = 2">物流信息</div></van-step>
			<van-step>提交</van-step>
		</van-steps>
	  <div class="st-form-content">
	    <st-form ref="form">
				 
				 <div v-show="act_step == 0">
					 <div class="st-form-title">基本信息</div>
					 <div class="st-form-group">
					 	<van-cell-group inset>
					 	
							<st-form-item key="code" label="转仓编码" prop="code">
								 <van-field
									class="st-form-item-input readonly"
									v-model="formData.code"
									name="转仓编码"
									label=""
									placeholder="请填写转仓编码"
									:disabled="true"
								 />
							</st-form-item>
							
							<st-form-item key="warehouse_out_id" label="调出仓库" prop="warehouse_out_id">
								<st-select
								  v-model="formData['warehouse_out_id']"
									:def-text="formData['warehouse_out_name']"
								  name="warehouse_out_id"
								  placeholder="请选择调出仓库"
								  :options="$option['getWarehouse']"
									@change="warehouseOutChange"
								>
								</st-select>
							</st-form-item>
							
							<st-form-item key="warehouse_in_id" label="调入仓库" prop="warehouse_in_id">
								<st-select
								  v-model="formData['warehouse_in_id']"
									:def-text="formData['warehouse_in_name']"
								  name="warehouse_in_id"
								  placeholder="调入仓库"
								  :options="$option['getWarehouse']"
									@change="warehouseInChange"
								>
								</st-select>
							</st-form-item>
							
							
							<st-form-item key="currency_type" label="转仓类型" prop="currency_type" :required="true">
								<st-select
								  v-model="formData['currency_type']"
								  name="转仓类型"
								  placeholder="转仓类型"
								  :options="$option['transfer_type']"
								>
								</st-select>
							</st-form-item>
							
							<st-form-item key="batch" label="转仓批次" prop="batch">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.batch"
									 name="转仓批次"
									 label=""
									 placeholder="请填写转仓批次"
								 />
							</st-form-item>
						
					 	
						
							<st-form-item key="remark" label="备注" prop="remark">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.remark"
									 name="备注"
									 label=""
									 placeholder="请填写备注"
								 />
							</st-form-item>
					 
					  </van-cell-group>
					 </div>
					 
				 </div>
				 
				 <div v-show="act_step == 1">
					 <div class="st-form-title">产品信息</div>
					 
					 <div class="st-form-group">
					   <van-cell-group inset>
					     <div class="product-item" v-for="(v, k) in formData['items']" :key="k">
					       <div class="prudcut-del-box" v-if="formData['items'].length > 1" @click="delItem(k)"><i class="el-icon-close"></i></div>
					       <h3 style="text-align: center;">产品{{ k + 1 }}</h3>
					 
					       <st-form-item :key="`items.${k}.inventory_id`" label="SKU" :prop="`items.${k}.inventory_id`" :required="true">
					         <st-select
					           v-model="formData['items'][k]['inventory_id']"
										 :def-text="formData['items'][k]['val_name']"
					           name="SKU"
					           placeholder="请选择SKU"
					           :options="$option['getInventorySkuList']"
										 :custom-params="{'warehouse_id': formData['warehouse_out_id']}"
										 @change="skuChange(k)"
										 :click-before="skuClickBefore"
					         >
					         </st-select>
					       </st-form-item>
					 
					       <st-form-item label="产品名称" :prop="`items.${k}.pname`">
					         <van-field
					           class="st-form-item-input readonly"
					           v-model="formData['items'][k]['pname']"
					           name="产品名称"
					           label=""
					           placeholder="请输入产品名称"
										 disabled
					         />
					       </st-form-item>
					 			
					 			<st-form-item label="进出口单号" :prop="`items.${k}.import_order`">
					 			  <van-field
					 			    class="st-form-item-input"
					 			    v-model="formData['items'][k]['import_order']"
					 			    name="进出口单号"
					 			    label=""
					 			    placeholder="请输入进出口单号"
					 			  />
					 			</st-form-item>
								
								<st-form-item label="报关价值" :prop="`items.${k}.exportdeclarationvalue`">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData['items'][k]['exportdeclarationvalue']"
								    name="报关价值"
								    label=""
								    placeholder="请输入报关价值"
								  />
								</st-form-item>
								
								<st-form-item label="海关汇率" :prop="`items.${k}.exchange_rate`">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData['items'][k]['exchange_rate']"
								    name="海关汇率"
								    label=""
								    placeholder="请输入海关汇率（注意币种）"
								  />
								</st-form-item>
					 
					       <st-form-item label="转仓数量" :prop="`items.${k}.quantity`" :required="true">
					         <van-field
					           class="st-form-item-input"
					           v-model="formData['items'][k]['quantity']"
					           name="转仓数量"
					           label=""
					           placeholder="请输入转仓数量"
					         />
									 <span style="padding-left: 8px;font-size: 12px;color: #d87d13;">库存：{{ formData['items'][k]['stocknum'] }}</span>
					       </st-form-item>
					 
					     </div>
					     
					   </van-cell-group>
					   <div style="margin: 16px;" class="new-pruduct-btn-box">
					     <button class="new-pruduct-btn" @click="newItem">
					       <i class="el-icon-plus"></i>
					     </button>
					   </div>
					 </div>
					 
				 </div>
				 
				 <div v-show="act_step == 2">
				 		<div class="st-form-title">物流信息</div>
						 <div class="st-form-group">
						 	<van-cell-group inset>
						 	
								<st-form-item key="shippingmethods" label="物流方式" prop="shippingmethods">
									<st-select
									  v-model="formData['shippingmethods']"
									  name="shippingmethods"
									  placeholder="物流方式"
									  :options="$option['shippingmethods']"
									>
									</st-select>
								</st-form-item>
								
								<st-form-item key="out_tax_number" label="出口税号" prop="out_tax_number">
									 <van-field
										class="st-form-item-input"
										v-model="formData.out_tax_number"
										name="出口税号"
										label=""
										placeholder="请填写出口税号"
									 />
								</st-form-item>
								
								<st-form-item key="in_tax_number" label="进口税号" prop="in_tax_number">
									 <van-field
										class="st-form-item-input"
										v-model="formData.in_tax_number"
										name="进口税号"
										label=""
										placeholder="请填写进口税号"
									 />
								</st-form-item>
								
								<st-form-item key="customs_declaration_number" label="报关单号" prop="customs_declaration_number">
									 <van-field
										class="st-form-item-input"
										v-model="formData.customs_declaration_number"
										name="报关单号"
										label=""
										placeholder="请填写报关单号"
									 />
								</st-form-item>
								
								<st-form-item key="taxation" label="税费" prop="taxation">
									 <van-field
										class="st-form-item-input"
										v-model="formData.taxation"
										name="税费"
										label=""
										placeholder="请填写税费"
									 />
								</st-form-item>
								
								<st-form-item key="cost" label="费用" prop="cost">
									 <van-field
										class="st-form-item-input"
										v-model="formData.cost"
										name="费用"
										label=""
										placeholder="请填写费用"
									 />
								</st-form-item>
								
								<st-form-item key="purchasingtracking" label="物流商" prop="purchasingtracking">
									<st-select
									  v-model="formData['purchasingtracking']"
									  name="物流商"
									  placeholder="请选择物流商"
									  :options="$option['getExpress']"
										:def-text="formData['purchasingtracking_name']"
									>
									</st-select>
								</st-form-item>
								
								<st-form-item key="logisticsnumber" label="运单号" prop="logisticsnumber">
									 <van-field
										class="st-form-item-input"
										v-model="formData.logisticsnumber"
										name="运单号"
										label=""
										placeholder="请填写运单号"
									 />
								</st-form-item>
								
								<st-form-item key="out_fare" label="发货人运费" prop="out_fare">
									 <van-field
										class="st-form-item-input"
										v-model="formData.out_fare"
										name="发货人运费"
										label=""
										placeholder="请填写发货人运费"
									 />
								</st-form-item>
								
								<st-form-item key="in_fare" label="收货人运费" prop="in_fare">
									 <van-field
										class="st-form-item-input"
										v-model="formData.in_fare"
										name="收货人运费"
										label=""
										placeholder="请填写收货人运费"
									 />
								</st-form-item>
								
								<st-form-item key="receiver_name" label="收货人" prop="receiver_name">
									 <van-field
										class="st-form-item-input"
										v-model="formData.receiver_name"
										name="收货人"
										label=""
										placeholder="请填写收货人"
									 />
								</st-form-item>
								
								<st-form-item key="phone" label="收货人电话" prop="phone">
									 <van-field
										class="st-form-item-input"
										v-model="formData.phone"
										name="收货人电话"
										label=""
										placeholder="请填写收货人电话"
									 />
								</st-form-item>
								
								<st-form-item key="destination_address" label="详细地址" prop="destination_address">
									 <van-field
										class="st-form-item-input"
										v-model="formData.destination_address"
										name="详细地址"
										label=""
										placeholder="请填写详细地址"
										type="textarea"
									 />
								</st-form-item>
								
								<st-form-item key="out_remark" label="发货备注" prop="out_remark">
									 <van-field
										class="st-form-item-input"
										v-model="formData.out_remark"
										name="发货备注"
										label=""
										placeholder="请填写发货备注"
										type="textarea"
									 />
								</st-form-item>
								
								<st-form-item key="in_remark" label="收货备注" prop="in_remark">
									 <van-field
										class="st-form-item-input"
										v-model="formData.in_remark"
										name="收货备注"
										label=""
										placeholder="请填写收货备注"
										type="textarea"
									 />
								</st-form-item>
								
							</van-cell-group>
						</div>
				 </div>
				 <div style="width: 100vw;bottom: 0;position: sticky;margin-left: -16px;padding: 8px 0px 16px;background: rgba(202,192,192, 0.5)">
						 <div class="form-submit-button" style="margin: 0px 16px;">
							 <van-button v-if="act_step > 0" round block type="default"  @click="act_step--">
								 上一步
								</van-button>
								<van-button v-if="act_step < 2" round block type="default"  @click="act_step++">
								 下一步
								</van-button>
							 <van-button round block type="primary"  @click="onSubmit">
								提交
							 </van-button>
						 </div>
				 	
				 </div>
				 
			</st-form>
		</div>
	</div>
</template>

<script>
	import StHeader from "@/components/layout/Header.vue";
	import StFormItem from "@/components/formItem.vue";
	import StForm from "@/components/form.vue";
	import StFileUpload from "@/components/FileUpload.vue";
	import StSelect from "@/components/Select.vue";
	import StDate from "@/components/Date.vue";
	import StArea from "@/components/Area.vue";

	export default {
		components: {
			StHeader,
			StFormItem,
			StForm,
			StFileUpload,
			StSelect,
			StDate,
			StArea,
			floading: false,
		},
		props: {},
		data() {
		  return {
				act_step: 0,
		    formData: {
					items: [{}],
					is_overseas: '1',
					quota_switch: false,
					warehouse_out_id: '',
				},
			}
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		    init() {
					let query = this.$route.query;
					if (query.id) this.formData.id = query.id;
					this.getInfo();
		    },
				
				// 产生单号
				generateOrderNumber() {
				    const now = new Date();
				    const yearMonth = now.getFullYear().toString().slice(-2) + (now.getMonth()+1).toString().padStart(2, '0');
				    const dayHour = now.getDate().toString().padStart(2, '0') + now.getHours().toString().padStart(2, '0');
				    const minutesSeconds = now.getMinutes().toString().padStart(2, '0') + now.getSeconds().toString().padStart(2, '0');
				    const datePart = yearMonth + '-' + dayHour + '-' + minutesSeconds;
				    
				    const randomNumber = ('0000' + Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)).slice(-4);
				
				    return 'TF-' + datePart + '-' + randomNumber;
				},
				getInfo() {
						if(!this.formData.id) {
							this.formData.code = this.generateOrderNumber();
							return;
						}
						this.floading = true;
						
						this.$post(this.$api.transferEditInfo, {id: this.formData.id}).then((res) => {
							if (res.code != 1) {
								this.$toast.fail(res.msg ? res.msg : '获取异常');
								return;
							}
							let data = res.data;
							// data.currency_type = data.currency_type + '';
							data.shippingmethods = data.shippingmethods + '';
							this.$set(this, ['formData'], data);
							this.floading = false;
						});
				},
				
				warehouseOutChange() {
					if (this.formData.warehouse_in_id == this.formData.warehouse_out_id) {
						this.$toast.fail('调入仓不能和调出仓一样');
					}
				},
				warehouseInChange() {
					if (this.formData.warehouse_in_id == this.formData.warehouse_out_id) {
						this.$toast.fail('调入仓不能和调出仓一样');
					}
				},
				// sku下拉项点击前执行
				skuClickBefore() {
					if (!this.formData.warehouse_out_id) {
						this.$toast.fail('请选择上一步的调出仓库');
						return false;
					}
					
					return true;
				},
				async skuChange(ind) {
					let id = this.formData.items[ind].inventory_id;
					await this.getSkuById(id).then(res => {
						this.formData.items[ind].pname = res.data.pname;
						this.formData.items[ind].sku = res.data.psku;
						this.formData.items[ind].stocknum = res.data.stocknum;
						this.formData.items[ind].products_id = res.data.products_id;
						this.formData.items[ind].qty = res.data.qty;
						this.$forceUpdate();
					});
					
					
				},
				
				async getSkuById(id) {
					return await this.$post(this.$api.stGetInventorySkuById, { 'ids': id });
				},
				// 创建一个产品
				newItem() {
				  this.formData.items.push({});
				},
				// 删除一个产品
				delItem(index) {
				  this.formData.items.splice(index, 1);
				},
		    // 提交代码
		    onSubmit() {
		      let formValid = false;
		      this.$refs.form.validater.valid((isValid, lastMsg) => { 
		        formValid = isValid;
		        if (!isValid) {
		          this.$toast.fail('表单异常：' + lastMsg);
		        }
		      });
		      // 校验不通过
		      if (!formValid) return;
					
					if (this.formData.warehouse_in_id == this.formData.warehouse_out_id) {
						this.$toast.fail('调入仓不能和调出仓一样');return;
					}
					
		      let formData = JSON.parse(JSON.stringify(this.formData));
					if (!this.formData.id) {
						this.$post(this.$api.transferAdd, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("创建转仓单成功");
						    this.$router.replace('/transfern/list');
						  }
						});
					} else {
						this.$post(this.$api.transferEdit, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("编辑转仓单成功");
						    this.$router.replace('/transfern/list');
						  }
						});
					}
		      
		      
		    },
		  },
		
	}
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;

  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
		padding: 20px 0px;
		border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .product-item {
      background-color: rgba(230, 236, 241, 1);
      padding: 15px;
      margin-top: 18px;

      .prudcut-del-box {
        margin-top: -10px;
        float: right;
        text-align: right;
        font-size: 31px;
        color: rgba(227, 60, 100, 1);
      }
    }

    .new-pruduct-btn {
      width: 317px;
      height: 44px;
      border-radius: 5px;
      color: rgba(80, 80, 80, 1);
      background: rgba(42, 130, 228, 1);
      line-height: 150%;
      border: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;

      .el-icon-plus {
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-weight: bolder;
      }
    }
  }

	.form-submit-button {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-bettwen;
		gap: 10px;
		button {
			min-width: 45%;
			flex: 1;
		}
	}

  .static {
    display: flex;
    justify-content: space-around;
    height: 70px;
    background-color: rgba(56, 56, 56, 1);
    font-size: 14px;
    line-height: 150%;
    align-items: center;

    div {
      text-align: center;
    }

    border-radius: 0px,0px,5px,5px;
  }
	
	.readonly {
	  background-color: rgba(233, 233, 233, 1);
	}
}

</style>
